import { EditInputCell } from 'components';
import { GridRenderEditCellParams } from '@mui/x-data-grid-premium';

const RenderEditItem = (params: GridRenderEditCellParams) => <EditInputCell {...params} />;

export default RenderEditItem;
